var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"500","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.file)?_c('v-card',[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_c('div',{staticClass:"subtitle-2"},[_vm._v("Uploaded File")])]),_c('v-divider'),_c('v-img',{attrs:{"src":_vm.file}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }